import { writable } from 'svelte/store';
import previewAreaLoadingStore from '../../pages/preview/loading-store';
const initialState = {
    progress: 0,
    isComplete: false,
    captureState: 'none',
    compileState: 'none',
    completedRequestId: '',
    downloadableUrl: null
};
// Init state
const { subscribe, update, set } = writable(structuredClone(initialState));
const actions = {
    reset: () => {
        set(structuredClone(initialState));
    },
    set: (updatedState) => {
        update(store => ({ ...store, ...updatedState }));
    },
    updateProgress: (value) => {
        update(store => ({ ...store, isComplete: false, progress: value }));
    },
    complete: (completedRequestId, downloadableUrl) => {
        previewAreaLoadingStore.set(false);
        update(store => ({ ...store, isComplete: true, completedRequestId, downloadableUrl }));
    },
    setCaptureState: (state) => {
        update(store => ({ ...store, captureState: state }));
    },
    setCompileState: (state) => {
        update(store => ({ ...store, compileState: state }));
    }
};
const download = {
    ...actions,
    subscribe
};
export default download;
